import { EntreeJournal } from 'src/app/core/services/entities/journal.service';
import { RoleUtil } from './role.util';

/** Modules du journal (null ou FERME = toute la ferme) */
export const MODULES_JOURNAL: { code: string; libelle: string; icone: string }[] = [
  { code: 'POULAILLER', libelle: 'Poulailler', icone: 'egg' },
  { code: 'BASSINS', libelle: 'Bassins', icone: 'water' },
  { code: 'CHEPTEL', libelle: 'Cheptel', icone: 'pets' },
  { code: 'CULTURES', libelle: 'Cultures', icone: 'eco' },
  { code: 'FERME', libelle: 'Toute la ferme', icone: 'home_work' },
];

const ACTIONS: Record<string, string> = {
  CREATE: 'Création', UPDATE: 'Modification', DELETE: 'Suppression', VALIDATE: 'Validation', REJECT: 'Refus',
  RECOMPTAGE: 'Recomptage', COMPTAGE_CONFIRME: 'Comptage confirmé', SELL: 'Vente', DEATH: 'Mortalité', DONE: 'Tâche faite',
  STATUS: 'Changement de statut', ROLE: 'Changement de rôle', EMIT: 'Émission', CANCEL: 'Annulation', PAID: 'Paiement',
  INVENTORY: 'Inventaire', RECEPTION: 'Réception', LOW_STOCK: 'Stock bas',
};

/** Types d'éléments qui ont une fiche, par route ; certains selon les droits de l'écran */
function routeElement(type: string, id: number | string): any[] | null {
  const personnel = RoleUtil.estPersonnel() || RoleUtil.estContenu();
  switch (type) {
    case 'LotVolaille': return ['/volaille/details', id];
    case 'Bassin': return ['/bassins/details', id];
    case 'Pisciculture': return ['/pisciculture/details', id];
    case 'Troupeau': return ['/betail/troupeau/details', id];
    case 'Animal': return ['/betail/details', id];
    case 'Culture': return ['/maraichage/details', id];
    case 'StockArticle': return ['/stock', id];
    case 'Equipement': return ['/equipements', id];
    case 'Tache': case 'Routine': return ['/taches'];
    case 'Facture': return RoleUtil.voitFinancesFerme() ? ['/factures/details', id] : null;
    case 'Contact': return personnel ? null : ['/contacts-crm', id];
    case 'Revenu': case 'Depense': case 'Paiement': return personnel ? null : ['/finances'];
    case 'Document': return personnel || RoleUtil.gestionnaireLimite() ? null : ['/ged/document', id];
    case 'SaisieEnAttente': case 'DepenseTerrain':
      return RoleUtil.gereExploitation() || RoleUtil.estComptable() ? ['/validations'] : null;
    case 'Membre': return personnel ? null : ['/users'];
    default: return null;
  }
}

export class JournalUtil {
  static libelleAction(a: string): string {
    return ACTIONS[a] || (a ? a.charAt(0) + a.slice(1).toLowerCase().replace(/_/g, ' ') : '');
  }

  static module(code?: string | null) {
    return MODULES_JOURNAL.find(m => m.code === (code || 'FERME')) || MODULES_JOURNAL[MODULES_JOURNAL.length - 1];
  }

  /** Date UTC sans zone → Date locale */
  static date(d: string): Date {
    return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(d) ? d : d + 'Z');
  }

  static initiales(nom?: string): string {
    const m = (nom || '').trim().split(/\s+/).filter(x => !!x);
    return ((m[0]?.[0] || '') + (m.length > 1 ? m[m.length - 1][0] : '')).toUpperCase() || '?';
  }

  /** Fiche de l'élément, si elle existe encore et que l'écran est ouvert à ce rôle */
  static lien(e: EntreeJournal): any[] | null {
    if (!e.elementType || e.elementId == null || e.action === 'DELETE') { return null; }
    return routeElement(e.elementType, e.elementId);
  }

  /** « Mon activité » : le Personnel et le rédacteur ne voient que leurs actions */
  static seulementMoi(): boolean { return RoleUtil.estPersonnel() || RoleUtil.estContenu(); }

  /** Message d'un refus ou d'une erreur, la page reste ouverte */
  static messageErreur(err: any): string {
    if (err?.status === 403) { return err?.error?.message || 'Vous n\'avez pas accès à cette partie du journal.'; }
    return 'Impossible de charger le journal. Vérifiez votre connexion puis réessayez.';
  }
}
